import User from '@/models/User';

export function handleUserFullName(
  names?: Pick<User, 'firstName' | 'lastName'> | null,
): string {
  const fullName = `${names?.firstName} ${names?.lastName}`;
  return names ? fullName : '';
}
